import { z } from 'zod';
import { WORKSPACE_ROLES } from '../constants.js';
import { emailSchema, slugSchema, uuidSchema } from './primitives.js';

export const createWorkspaceInput = z.object({
  name: z.string().min(2).max(120),
  slug: slugSchema,
});
export type CreateWorkspaceInput = z.infer<typeof createWorkspaceInput>;

export const inviteMemberInput = z.object({
  workspaceId: uuidSchema,
  email: emailSchema,
  role: z.enum(WORKSPACE_ROLES).default('editor'),
});
export type InviteMemberInput = z.infer<typeof inviteMemberInput>;

export const registerUserInput = z.object({
  email: emailSchema,
  password: z.string().min(10).max(128),
  name: z.string().min(1).max(120),
  consents: z.object({
    tos: z.literal(true),
    privacy: z.literal(true),
    marketing: z.boolean().default(false),
    ai_processing: z.boolean().default(false),
  }),
});
export type RegisterUserInput = z.infer<typeof registerUserInput>;

export const loginInput = z.object({
  email: emailSchema,
  password: z.string().min(1).max(128),
});
export type LoginInput = z.infer<typeof loginInput>;
